<template>
  <div class="chart" ref="chart"></div>
</template>

<style>
.chart {
  width: 100%;
  height: 100%;
}
</style>

<script>
import { addListener, removeListener } from 'resize-detector'
import { debounce } from 'lodash'
// import echarts from 'echarts'
var echarts = require('echarts');
import { getOptionColorstr } from '@/util'
// import Theme1 from "./theme1";
// import Theme2 from "./theme2";
// import Theme3 from "./theme3";
// import Theme4 from "./theme4";
import { on, off } from '@/util/tools';
// VueCharts.registerTheme("Theme1", Theme1);
// VueCharts.registerTheme("Theme2", Theme2);
// VueCharts.registerTheme("Theme3", Theme3);
// VueCharts.registerTheme("Theme4", Theme4);
// 基本水球图
require('echarts-liquidfill');
// todo: cs场景时，preScene不展示
// 动态数据option解析有问题，待开发

export default {
  name: 'BaseEchart',
  props: {
    option: {
      type: String | Object,
      required: false,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      required: false,
      default: () => {
        return 'Theme1'
      }
    },
    advanceMode: {
      type: Boolean | Number | String,
      default: () => {
        return false
      }
    }
  },
  data(){
    return {
      chart: null,
      resizeHandler: null,
      lastArea: 0
    }
  },
  computed: {
    realOption() {
      let option
      if (this.advanceMode && this.option) {
        try {
          option = JSON.parse(this.option)
        } catch (error) {
          var fun = new Function("echarts", `var option = null \n ${this.option} \n return option`)
          var responseData = fun(echarts);
          option = responseData;
        }
        // if (typeof this.option === 'string') {
        //   var fun = new Function("echarts", `var option = null \n ${this.option} \n return option`)
        //   var responseData = fun(echarts);
        //   option = responseData;
        // } else {
        //   option = this.option
        // }
      } else {
        if (typeof this.option !== 'string') return this.option
          // console.group('拼接option.color，返回可运行的实例')

          // 拼接有效的option字符串
          let evalStr = this.option.includes('_color')
            ? `var _color = ${getOptionColorstr(this.option)}; option = ${
                this.option
              }`
            : `option = ${this.option}`
          // 运行语句
          try {
            eval(evalStr)
          } catch (t) {
            console.log(t)
          }
          // console.log(option, '// option')
          // console.groupEnd();
      }
      return option
    }
  },
  methods: {
    refreshHandle() {
      if (this.chart) {
        this.handleDestroy()
        this.init()
      } else {
        this.chart.refresh()
      }
    },
    // new
    getArea () {
      return this.$el.offsetWidth * this.$el.offsetHeight
    },
    init() {
      if (this.chart) {
        return
      }
      const chart = echarts.init(this.$refs.chart)
      this.realOption && chart.setOption(this.realOption)
      Object.keys(this.$listeners).forEach(event => {
        const handler = this.$listeners[event]
        if (event.indexOf('zr:') === 0) {
          chart.getZr().on(event.slice(3), handler)
        } else {
          chart.on(event, handler)
        }
      })
      this.chart = chart
      this.lastArea = this.getArea()
      this.resizeHandler = debounce(
        () => {
          this.resize()
          this.lastArea = this.getArea()
        },
        50,
        { leading: true }
      )
      addListener(this.$el, this.resizeHandler)
    },
    resize() {
      this.chart && this.chart.resize()
    },
    handleDestroy() {
      this.chart.clear()
      removeListener(this.$el, this.resizeHandler)
      this.chart = null
      // console.log(this.chart)
    }
  },
  watch: {
    realOption: {
      handler(obj) {
        this.refreshHandle()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.handleDestroy()
  }
};
</script>
